<template>
  <v-toolbar
    color="primary"
    fixed
    dark
    app
    flat
    >
    <v-toolbar-title class="ml-0">
    </v-toolbar-title>
      <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-btn icon @click="handleFullScreen()">
        <v-icon>fullscreen</v-icon>
      </v-btn>
      <v-btn icon @click="DarkMode()">
        <v-icon>
          brightness_medium
        </v-icon>
      </v-btn>
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn icon large flat slot="activator">
          <v-icon>person</v-icon>
        </v-btn>
        <v-list class="pa-0">
        <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon v-if="item.icon">{{ item.icon }}</v-icon>&nbsp;
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      </v-menu>
  </v-toolbar>
</template>
<script>
import baseUrl from '@/api/axios/base_url';

import Util from '@/util';

export default {
  name: 'app-toolbar',
  data: () => ({
    role: null,
    items: [
      {
        href: "/#/logout",
        icon: 'exit_to_app',
        title: "Cerrar Sesión",
      }
    ]
  }),
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  created() {
    this.setRole();
  },
  methods: {
    handleDrawerToggle () {
      window.getApp.$emit('APP_DRAWER_TOGGLED');
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    },
    DarkMode(){
      window.getApp.$emit('DARK_MODE', true);
    },
    setRole(){
      if( window.localStorage.role !== undefined ){
        var role = localStorage.getItem('role')
          role = role.replace(/[ '"]+/g, '')
        this.role = role
      }
    }
  }
};
</script>